(function () {

  'use strict';

  function pxSite(
    SitesProviderService, SiteService, URL_PARAMS, $routeParams, TenantListService, URLS, $location,
    EventServiceEvents, $rootScope, $timeout, toastr, $filter, PrinterListService,
    PrinterListPOSTPaging, NetworkModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        tenant: '=tenant',
        enums: '=enums'
      },
      templateUrl: 'app/components/sites/site/site.template.html',
      link: function (scope) {

        scope.site = null;
        scope.siteLoading = false;
        scope.isThisSiteMine = true;

        scope.auxiliaries = {
          tenant: scope.tenant,
          me: scope.me,
          enums: scope.enums
        };

        (function () {
          setListeners();
          getInitialSite();
        })();

        // ONLY USE ON INITIAL LOAD OF CONTROLLER
        function getInitialSite() {
          let siteId;
          if ($routeParams[URL_PARAMS.SITES_IDS.ROUTE]) {
            siteId = $routeParams[URL_PARAMS.SITES_IDS.ROUTE].replace('?', '');
          }
          if (siteId) {
            getSiteFromUrl(siteId);
          } else if (SiteService.getSiteFromStorage()) {
            getSiteFromStorage();
          }
        }

        function getSiteFromUrl(siteId) {
          scope.siteLoading = true;
          const url = TenantListService.currentTenant.info._links['px:sites'].href + '/' + siteId;
          SitesProviderService.getSite(url)
            .then(function (site) {
              scope.isThisSiteMine = scope.me.isThisSiteMine(site.links.self.href);
              readSiteContent(site);
              scope.siteLoading = false;
            })
            .catch(function () {
              scope.siteLoading = false;
            });
        }

        function getSiteFromStorage() {
          scope.siteLoading = true;
          const storedSite = SiteService.getSiteFromStorage();
          SitesProviderService.getSite(storedSite.links.self.href)
            .then(function (site) {
              scope.isThisSiteMine = scope.me.isThisSiteMine(site.links.self.href);
              readSiteContent(site);
              updateURL();
              scope.siteLoading = false;
            })
            .catch(function (error) {
              if (error.status === 404) {
                SiteService.removeSiteFromStorage();
              }
              scope.siteLoading = false;
            });
        }

        function getSite(site) {
          scope.siteLoading = true;
          SitesProviderService.getSite(site.links.self.href)
            .then(function (site) {
              scope.isThisSiteMine = scope.me.isThisSiteMine(site.links.self.href);
              readSiteContent(site);
              updateURL();
              scope.siteLoading = false;
            })
            .catch(function () {
              scope.siteLoading = false;
            });
        }

        function readSiteContent(site) {
          // const storedSite = SiteService.getSiteFromStorage();
          // if (storedSite.id === site.id) {
          //   if (site.networkData) {
          //     restoreNetworkListOpenState(site, storedSite);
          //   }
          // }
          SiteService.putSiteInStorage(site);
          scope.site = site;
          checkForPrintersWithIssues(site);
        }

        scope.isSiteManaged = function (site) {
          return (site.siteAdminGroup && site.siteAdminGroup.length) ||
            (site.ancestors && site.ancestors.some(ancestor => ancestor.siteAdminGroup && ancestor.siteAdminGroup.length));
        };

        function checkForPrintersWithIssues(site) {
          const networks = [];

          angular.forEach(site.network, function (network) {
            networks.push(network.href);
          });

          const pagingObject = new PrinterListPOSTPaging();
          pagingObject.pagingCriteria.underCreation = true;
          pagingObject.pagingCriteria.networks = networks;
          pagingObject.pagingCriteria.pageSize = 100;
          if (site.embedded.network) {
            PrinterListService.postGetPrinterListPaged(pagingObject)
              .then(function (response) {
                if (response.networks) {
                  for (let i = 0; i < response.networks.length; i++) {
                    for (let j = 0; j < site.embedded.network.length; j++) {
                      if (response.networks[i]._links.self.href === site.embedded.network[j]._links.self.href) {
                        site.embedded.network[j].printersWithIssues = true;
                      }
                    }
                  }
                }
              })
              .catch(function () {
              });
          }
        }

        function restoreNetworkListOpenState(site, storedSite) {
          if (storedSite.networkData?.length) {
            for (let i = 0; i < site.networkData.length; i++) {
              for (let j = 0; j < storedSite.networkData.length; j++) {
                if (site.networkData[i]._links.self.href === storedSite.networkData[j]._links.self.href) {
                  site.networkData[i].open = storedSite.networkData[j].open;
                }
              }
            }
          }
        }

        function updateURL() {
          const url = URLS.SITES.replace(URL_PARAMS.SITES_IDS.LOCATION, SiteService.getSiteFromStorage().id);
          $location.path(url, false);
        }

        scope.toggleNetwork = function (network, site) {
          network.open = !network.open;
          if (network.open) {
            network.loadingPrinters = true;
          }
          SiteService.putSiteInStorage(site);
        };

        scope.hasMatchingNetworks = function (search) {
          const matchingItems = $filter('filter')(scope.site.embedded.network, search);
          return !!matchingItems && matchingItems.length > 0;
        };

        // TOOLTIP STUFF

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'network':
                networkTooltip(position, context);
                break;
              case 'statement':
                siteTooltip(position, context);
                break;
              case 'printer-link':
                printerLinkTooltip(position, context);
                break;
              case 'statement-fallback':
                toolTipFallback(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function networkTooltip(position, network) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Network',
            type: 'networkDetails',
            network,
            tenant: angular.copy(TenantListService.currentTenant)
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 }
          };
        }

        function toolTipFallback(position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title,
            type: 'statement-fallback'
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 }
          };
        }

        function siteTooltip(position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title,
            type: 'statement'
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        function printerLinkTooltip(position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'multipleStatements',
            tooltips: [
              { icon: null, tip: 'Click to open {SignID} printer in a new tab' }
            ]
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 }
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        // CONTEXT MENUS

        scope.openFolderContext = function (event, folder) {
          scope.closeAllMenues();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $timeout(function () {

            const menuItems = [
              { title: 'FolderName',           selected: false, type: 'rename',          breaker: false, order: 6, disabled: scope.me.isSystemObserver() },
              { title: 'SiteManagerGroups',    selected: false, type: 'siteManagers',    breaker: true,  order: 5, bypassCloseOutside: true },
              { title: 'AddSiteManagerGroups', selected: false, type: 'addSiteManagers', breaker: true,  order: 4, disabled: scope.me.isSystemObserver(), bypassCloseOutside: true },
              { title: 'NewFolder',            selected: false, type: 'COLLECTION',      breaker: false, order: 3, disabled: scope.me.isSystemObserver() },
              { title: 'CreateSite',           selected: false, type: 'SINGLE',          breaker: true,  order: 2, disabled: scope.me.isSystemObserver() },
              { title: 'DeleteFolder',         selected: false, type: 'deleteSite',      breaker: false, order: 1, disabled: scope.me.isSystemObserver() }
            ];
            if (folder.level === 3) {
              menuItems.splice(3, 1);
            }

            scope.menuContent = {
              menuItems,
              context: folder,
              icon: 'icon-folder',
              sizeClass: 'size115',
              type: 'FOLDER'
            };
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'FOLDER'
            };
          });
        };

        scope.openSiteContext = function (event, site) {
          scope.closeAllMenues();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                { title: 'SiteName',             selected: false, type: 'rename',          breaker: false, order: 6, disabled: scope.me.isSystemObserver() },
                { title: 'SiteManagerGroups',    selected: false, type: 'siteManagers',    breaker: false, order: 5, bypassCloseOutside: true },
                { title: 'Networks',             selected: false, type: 'siteNetworks',    breaker: true,  order: 4 },
                { title: 'AddSiteManagerGroups', selected: false, type: 'addSiteManagers', breaker: false, order: 3, disabled: scope.me.isSystemObserver(), bypassCloseOutside: true },
                { title: 'AddNetworks',          selected: false, type: 'addNetworks',     breaker: true,  order: 2, disabled: scope.me.isSystemObserver() },
                { title: 'DeleteSite',           selected: false, type: 'deleteSite',      breaker: false, order: 1, disabled: scope.me.isSystemObserver() }
              ],
              context: site,
              icon: 'icon-pin',
              sizeClass: 'size115',
              type: 'SITE'
            };
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'SITE'
            };
          });
        };

        scope.openNetworkContextMenu = function (event, network) {
          scope.closeAllMenues();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $rootScope.$broadcast('SITE_NETWORK_CONTEXT_CONTROL_META');
          $timeout(function () {
            scope.auxiliaries.network = new NetworkModel(network);
            scope.menuContent = {
              menuItems: [
                { title: 'NetworkName',           selected: false, type: 'rename',               breaker: false, order: 8, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine },
                { title: 'Settings',              selected: false, type: 'networkSetting',       breaker: false, order: 7 },
                { title: 'Gateways',              selected: false, type: 'gateways',             breaker: false, order: 6, warning: !network.gateways.length },
                { title: 'TestNetwork',           selected: false, type: 'testNetwork',          breaker: true,  order: 5 },
                { title: 'Computers',             selected: false, type: 'computers',            breaker: true,  order: 4 },
                { title: 'AddPrinter',            selected: false, type: 'addPrinter',           breaker: false, order: 3, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine },
                { title: 'DiscoverPrinters',      selected: false, type: 'discoverPrinters',     breaker: true,  order: 2, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine },
                { title: 'AddGatewayViaComputer', selected: false, type: 'addComputerToNetwork', breaker: false, order: 1, disabled: scope.me.isSystemObserver() && !scope.isThisSiteMine }
              ],
              context: network,
              icon: 'icon-correct-network',
              sizeClass: 'size115',
              type: 'NETWORK'
            };

            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'NETWORK'
            };
          });
        };

        // scope.openPrinterContextMenu = function (event, printer) {
        //   scope.closeAllMenues();
        //   $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
        //   $timeout(function () {
        //     scope.menuContent = {
        //       menuItems: [
        //         { title: 'Setup',       selected: false, type: 'setup',       breaker: false, order: 4 },
        //         { title: 'Network',     selected: false, type: 'network',     breaker: false, order: 3 },
        //         { title: 'PrintQueues', selected: false, type: 'printQueues', breaker: true,  order: 2 },
        //         { title: 'Status',      selected: false, type: 'status',      breaker: false, order: 1 }
        //       ],
        //       context: printer.info,
        //       icon: 'icon-correct-network',
        //       sizeClass: 'size115',
        //       type: 'NETWORK'
        //     };
        //     scope.menuSpecs = {
        //       position: { left: event.clientX, top: event.clientY },
        //       type: 'NETWORK'
        //     };
        //   });
        // };

        scope.openNetworkToolContextMenu = function (event, site) {
          scope.closeAllMenues();
          $rootScope.$broadcast('SITE_CONTEXT_CONTROL');
          $timeout(function () {
            scope.menuContent = {
              menuItems: [
                { title: 'AddNetworks',   selected: false, type: 'addNetworks',   breaker: false, order: 2 },
                { title: 'AddNewNetwork', selected: false, type: 'addNewNetwork', breaker: false, order: 1 }
              ],
              context: site,
              icon: 'icon-correct-network',
              sizeClass: 'size115',
              type: 'NETWORK'
            };
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'NETWORK'
            };
          });
        };

        scope.closeAllMenues = function (selectedContextMenuItem, contextContentPosition, contextContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem = null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          $timeout(function () {
            scope.selectedContextMenuItem = selectedContextMenuItem;
            scope.contextContentPosition = contextContentPosition;
            if (selectedContextMenuItem && selectedContextMenuItem.type === 'addGatewayToNetwork') {
              scope.contextContent = {
                context: {
                  network: new NetworkModel(contextContent.context),
                  name: 'AddGateway',
                  translate: true
                }
              };
            } else {
              scope.contextContent = contextContent;
            }
          });
        };

        // QUICK OPEN CONTEXTUAL MENU

        scope.quickOpenSiteMenu = function (event, context, menuOption, additionalContent) {
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.selectedContextMenuItem  =  null;
          scope.contextContentPosition = null;
          scope.contextContent = null;
          $timeout(function  () {
            scope.selectedContextMenuItem  =  menuOption;
            scope.contextContentPosition = { left: event.clientX, top: event.clientY };
            scope.contextContent = context;
            if (additionalContent) {
              scope.contextContent.additionalContent = additionalContent;
            }
          });
        };

        // QUIT SETUP GUIDE

        scope.forceQuitSetupGuide = function () {
          scope.site.forceQuitSetupGuide()
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function () {
            });
        };

        // LISTENERS

        function setListeners() {
          scope.$on('UPDATE_SELECTED_SITES', function (event, site) {
            if (!scope.site || scope.site.id !== site.id) {
              getSite(site);
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_UPDATED, function (event, data) {
            if (scope.site && scope.site.links.self.href === data.site) {
              getSite(scope.site);
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_SITE_DELETED, function (event, data) {
            if (scope.site && scope.site.links.self.href === data.site) {
              scope.site = null;
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_CHANGED, function (event, data) {
            if (scope.site) {
              for (let i = 0; i < scope.site.network.length; i++) {
                if (data.network === scope.site.network[i].href) {
                  getSite(scope.site);
                }
              }
            }
          });
        }

        const deregisterSiteTreeContextControlListener = $rootScope.$on('SITE_TREE_CONTEXT_CONTROL', function () {
          scope.closeAllMenues(null, null, null);
        });

        const deregisterSiteListContextControlListener = $rootScope.$on('SITE_LIST_CONTEXT_CONTROL', function () {
          scope.closeAllMenues(null, null, null);
        });

        scope.$on('$destroy', function () {
          deregisterSiteTreeContextControlListener();
          deregisterSiteListContextControlListener();
        });
      }
    };
  }

  pxSite.$inject = [
    'SitesProviderService', 'SiteService', 'URL_PARAMS', '$routeParams', 'TenantListService', 'URLS', '$location',
    'EventServiceEvents', '$rootScope', '$timeout', 'toastr', '$filter', 'PrinterListService',
    'PrinterListPOSTPaging', 'NetworkModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxSite', pxSite);

})();
